<template>
    <ol
        role="list"
        class="space-y-4 md:flex md:space-x-8 md:space-y-0"
    >
        <slot />
    </ol>
</template>
